var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoche(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.076,
    height: 12.076,
    viewBox: "0 0 12.076 12.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M5.937,12.076A6.2,6.2,0,0,1,.016,7.6a.445.445,0,0,1,.132-.439.421.421,0,0,1,.439-.132,4.942,4.942,0,0,0,1.4.219A5.278,5.278,0,0,0,7.252,1.99a4.942,4.942,0,0,0-.219-1.4A.445.445,0,0,1,7.165.148.421.421,0,0,1,7.6.016a6.146,6.146,0,0,1-1.666,12.06ZM1.113,8.086A5.275,5.275,0,0,0,11.2,5.937,5.331,5.331,0,0,0,8.085,1.113a5.877,5.877,0,0,1,.044.877A6.158,6.158,0,0,1,1.99,8.129,6.177,6.177,0,0,1,1.113,8.086Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoche);
export default __webpack_public_path__ + "static/media/noche.8ef311bce1864f675bf13dcf1605a6fd.svg";
export { ForwardRef as ReactComponent };